const httpProtocol = process.env.REACT_APP_USE_SSL === "true" ? "https" : "http"
const wsProtocol = process.env.REACT_APP_USE_SSL === "true" ? "wss" : "ws"
const backendURL = `${httpProtocol}://${process.env.REACT_APP_BACKEND_HOST}`
const wsBackendURL = `${wsProtocol}://${process.env.REACT_APP_BACKEND_HOST}`

export {backendURL, wsBackendURL}
